import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/tracking-scan`;
const PROFILE_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/customerprofile`;

const scan = (trackingJp, peek = false) => axios.post(`${BASE}/scan`, { trackingJp, peek });

const logShipmentGroupScan = (payload) => axios.post(`${BASE}/log-shipment-group`, payload);

const getScanLogs = (limit = 100, source = null) =>
  axios.get(BASE, { params: { limit, ...(source && { source }) } });

const searchByUrl = (url) => axios.post(`${BASE}/search-by-url`, { url });

const searchByName = (query) => axios.post(`${BASE}/search-by-name`, { query });

const TrackingScanService = { scan, logShipmentGroupScan, getScanLogs, searchByName, searchByUrl };
export default TrackingScanService;
